module.exports = __webpack_public_path__ + "img/dynamic-text-for-your-music-promotion.77becfab.jpg";